export default __webpack_public_path__ + "static/RunLeft10-123c2e5e6d9caa13e1ec6a2b4ad8358d.mp3";